import React, { useCallback, useEffect, useState } from "react";

import Iconify from "../iconify";
import IconCode from "@/src/lib/iconCode";
import { VisitTypeSwitchButton } from "./visitTypeSwitchButton";
import VisitTypeForm from "./visitTypeForm";
import ActionButtons from "./actionButtons";
import SampleReport from "./sampleReport";
import { useRouter } from "next/router";
// import ConfirmDialog from "../confirm-dialog/ConfirmDialog";
import ConfirmDialog from "@/src/lib/ui/confirmDialog";
import RemoveCart from "./removeCart";
import { useToast } from "@/src/lib/hooks/useToast";
import { useDispatch, useSelector } from "react-redux";
import SelectPatientForm from "./selectPatientPopup";
import { testApiService } from "@/src/lib/api-services/testApiServices";
import { VISITTYPE } from "@/src/lib/util/config";
import LoginPopUp from "../common/loginPopUp";
import { addProducts, replaceCart } from "@/src/lib/store/add-to-cart/slice";
import ChangeCentre from "./changeCentre";
import ErrorPopup from "../common/errorPopup";
import AddressMismatchPopup from "./addressMismatchPopup";
import { useCustomQuery } from "@/src/lib/hooks/useFetch";
import { cartApiService } from "@/src/lib/api-services/cartApiServices";
import useAuth from "@/src/lib/hooks/useAuth";
import { useHODMutation } from "@/src/lib/hooks/useHODMutation";
import CustomIconButton from "@/src/lib/ui/iconButton";

const TestActionAndControlSection = ({
    testDetails,
    handleTestSelection,
    currentTest,
    ISLOGGEDIN,
    setCurrentType,
}) => {
    const { query, push } = useRouter();
    const reduxdispatch = useDispatch();
    const { showCustomToast } = useToast();
    const { isLoggedIn } = useAuth();

    const { refetch: isCartCountRefetch } = useCustomQuery(
        "cart_count",
        cartApiService.getCartCount,
        {
            enabled: isLoggedIn && isLoggedIn,
            staleTime: 2000, // Adjust to avoid refetching too often
        }
    );

    const [openUpdateCartPopup, setOpenUpdateCartPopup] = useState(false);
    const [openChangeCentre, setOpenChangeCentre] = useState(false);
    const [patientPopupFlag, setPatientPopupFlag] = useState(false);
    const [visitType, setVisitType] = useState(VISITTYPE.CENTRE);
    const [currentCentre, setCurrentCentre] = useState(null);
    const [loginPopUp, setLoginPopUp] = useState(false);
    const isTestInCart = useSelector((state) => state?.addToCart?.addProducts);
    const [addToCartPayload, setAddToCartPayload] = useState(null);
    const [isAddressListOpen, setIsAddressListOpen] = useState(false);
    const [isMismatchOpen, setMismatchOpen] = useState(null);
    const [currentCity, setCurrentCity] = useState(null);

    const addressDetails = useSelector(
        (state) => state?.user?.userInfo?.addressDetails
    );

    const [error, setError] = useState("");

    const onClosePopup = () => {
        setError("");
    };

    const onClose = () => {
        setLoginPopUp(false);
    };

    const [testVariantDetails, setTestVariantDetails] = useState(
        testDetails?.configTest?.find(
            (test) => test?.itemId === testDetails?.defaultItemId
        )
    );

    const handleVisitTypeChange = (event, newValue) => {
        setVisitType(newValue);
        setCurrentType(newValue);
    };

    const onCloseHandler = () => {
        setOpenUpdateCartPopup(false);
    };

    const replaceCartHandler = (currentCentre) => {
        reduxdispatch(
            replaceCart({
                centreName: currentCentre?.centre,
                centreId: currentCentre?.centreId,
                centreTest: [
                    {
                        ...currentTest,
                        slug: query?.test_slug,
                        productId: testDetails?.productId,
                    },
                ],
            })
        );
        setOpenUpdateCartPopup(false);
        showCustomToast(
            `Cart is replaced with ${currentCentre?.centre}`,
            "success"
        );
    };

    const patientClose = () => {
        setPatientPopupFlag(false);
    };

    // console.log("cert_Details", cartDetails);

    const useCartMutation = (visitType, mutationFn) => {
        return useHODMutation(mutationFn, {
            onSuccess: (data) => {
                if (data?.data?.success) {
                    showCustomToast(data?.data?.message, "success");
                    patientClose();
                    isCartCountRefetch();
                    push(`/cart`);
                    // } catch (error) {
                    //     console.error("Session update failed: ", error);
                    //     setError("Failed to update session");
                    // }
                }
            },
            onError: (error) => {
                if (
                    error?.response?.data?.errorCode ===
                    "CENTRE_DETAILS_MISMATCH"
                ) {
                    patientClose();
                    setOpenChangeCentre(true);
                } else if (
                    error?.response?.data?.errorCode ===
                    "ADDRESS_DETAILS_MISMATCH"
                ) {
                    setMismatchOpen(error?.response?.data);
                } else {
                    //console.log("errorerrorerror", error);
                    const errorMsg =
                        error?.response?.data?.message ||
                        "Something went wrong testing!";

                    setError(errorMsg);
                }
            },
        });
    };

    const addToCentreCartMutation = useCartMutation(
        VISITTYPE.CENTRE,
        (payload) => testApiService.addToCentreCart({ payload })
    );

    const addToHomeCartMutation = useCartMutation(VISITTYPE.HOME, (payload) =>
        testApiService.addToHomeCart({ payload })
    );

    const addToCartHandler = (currentCentre, currentTest) => {
        if (!ISLOGGEDIN) {
            if (visitType.toLowerCase() === VISITTYPE.HOME) {
                setLoginPopUp(true);
                return;
            } else if (visitType.toLowerCase() === VISITTYPE.CENTRE) {
                const isItemAlreadyIncart = isTestInCart?.centreTest?.find(
                    (item) => item?.itemId === currentTest?.itemId
                );

                if (!!isTestInCart?.centreTest?.length) {
                    if (!(currentCentre?.centreId == isTestInCart?.centreId)) {
                        setOpenUpdateCartPopup(true);
                        return;
                    }
                }

                if (!!isItemAlreadyIncart) {
                    setError("Item already in cart");
                    return;
                }

                reduxdispatch(
                    addProducts({
                        centreName: currentCentre?.centre,
                        centreId: currentCentre?.centreId,
                        centreTest: [
                            {
                                ...currentTest,
                                slug: query?.test_slug,
                                productId: testDetails?.productId,
                            },
                        ],
                    })
                );

                showCustomToast("Item added to cart", "success");
            }
        } else {
            if (ISLOGGEDIN) {
                if (
                    visitType.toLowerCase() === VISITTYPE.HOME &&
                    !addressDetails?.pincode
                ) {
                    setError(
                        "Please select an address from list or create a new one."
                    );
                    return;
                } else if (!currentTest) {
                    setError("Please select a test");
                    return;
                } else {
                    setPatientPopupFlag(true);
                }
            }
        }
    };

    const handlePatientSubmit = (patients) => {
        const payload = {
            productId: testDetails?.productId,
            variantId: testVariantDetails?.itemId,
            itemName: testVariantDetails?.itemName,
            visitType: visitType,
            patientGuids: patients,
            discountRemark: "Discount",
            remark: "Remark",
        };

        if (visitType === VISITTYPE.CENTRE) {
            payload.centreId = currentCentre?.centreId;
            payload.updateCentre = false;
            payload.cityId = currentCity;
        } else {
            payload.addressDetails = {
                pincode: addressDetails?.pincode,
                addressGuid: addressDetails?.addressGuid,
            };
        }

        setAddToCartPayload(payload);
        if (visitType === VISITTYPE.HOME) {
            patients.length > 0 && addToHomeCartMutation.mutate(payload);
        } else patients.length > 0 && addToCentreCartMutation.mutate(payload);
    };

    const onCloseChangeCentreHandler = () => {
        setOpenChangeCentre(false);
    };

    const addToCart = () => {
        if (visitType === VISITTYPE.HOME) {
            addToHomeCartMutation.mutate(addToCartPayload);
        } else addToCentreCartMutation.mutate(addToCartPayload);
    };

    useEffect(() => {
        if (testDetails) {
            const currentType = !!testDetails?.isHcAllowed
                ? VISITTYPE.HOME
                : VISITTYPE.CENTRE;
            setVisitType(currentType);
            setCurrentType(currentType);
        }
    }, [testDetails]);

    useEffect(() => {
        if (currentTest && testDetails) {
            const selectedTestVariantDetails = testDetails.configTest.find(
                (test) => test?.itemId === currentTest?.itemId
            );
            setTestVariantDetails(selectedTestVariantDetails);
        }
    }, [currentTest]);

    const centreUpdateHandler = (centreType) => {
        const payload = {
            ...addToCartPayload,
            updateCentre: true,
            updateCentreType: centreType,
        };

        addToCentreCartMutation.mutate(payload);
    };

    return (
        <>
            <aside className="w-full md:w-[340px] lg:w-[380px] md:shrink-0 flex flex-col gap-4">
                <div className="rounded-xl border border-slate-200 bg-white shadow-sm">
                    <div className="p-5 md:p-6">
                    <VisitTypeSwitchButton
                        isHcAllowed={testDetails?.isHcAllowed}
                        handleVisitTypeChange={handleVisitTypeChange}
                        currentVisitType={visitType}
                    />
                    <VisitTypeForm
                        testDetails={testDetails}
                        handleTestSelection={handleTestSelection}
                        isLoading={false}
                        currentVisitType={visitType}
                        setCurrentCentre={setCurrentCentre}
                        currentCentre={currentCentre}
                        ISLOGGEDIN={ISLOGGEDIN}
                        currentTestInfo={currentTest}
                        addressDetails={addressDetails}
                        setIsAddressListOpen={setIsAddressListOpen}
                        isAddressListOpen={isAddressListOpen}
                        setCurrentCity={setCurrentCity}
                    />
                    </div>
                    <ActionButtons
                        currentTest={currentTest}
                        currentCentre={currentCentre}
                        testDetails={testDetails}
                        addToCartHandler={addToCartHandler}
                        ISLOGGEDIN={ISLOGGEDIN}
                        visitType={visitType}
                        addressDetails={addressDetails}
                        setIsAddressListOpen={setIsAddressListOpen}
                        setLoginPopUp={setLoginPopUp}
                    />
                </div>

                <SampleReport url={testVariantDetails?.sampleReport} />
            </aside>

            {!!openUpdateCartPopup && (
                <ConfirmDialog
                    open={!!openUpdateCartPopup}
                    currentCentre={currentCentre}
                    title={
                        <div className="flex justify-between items-center flex-row border-b border-gray-200 pb-4 -mx-4 px-4">
                            <div className="flex justify-center items-center flex-row">
                                <Iconify
                                    icon={IconCode.outlinedLocation}
                                    width={24}
                                    className="mr-2 text-primary"
                                />
                                <h4 className="text-xl font-bold">
                                    Confirm Centre
                                </h4>
                            </div>

                            <CustomIconButton onClick={onCloseHandler}>
                                <Iconify icon={IconCode.close} width={24} />
                            </CustomIconButton>
                        </div>
                    }
                    content={
                        <RemoveCart
                            currentCentre={currentCentre}
                            existingCartCentre={isTestInCart?.centreName}
                            replaceCartHandler={replaceCartHandler}
                            onCloseHandler={onCloseHandler}
                        />
                    }
                    maxWidth="md"
                    isCancel={true}
                />
            )}

            {!!openChangeCentre && (
                <ConfirmDialog
                    open={!!openChangeCentre}
                    title={
                        <div className="flex flex-row items-center justify-between border-b border-gray-200 pb-4 -mx-4 px-4">
                            <div className="flex flex-row items-center justify-center">
                                <Iconify
                                    icon={IconCode.location}
                                    width={24}
                                    className="mr-2 text-primary"
                                />
                                <h4 className="text-xl font-bold">
                                    Confirm Centre
                                </h4>
                            </div>

                            <CustomIconButton
                                onClick={onCloseChangeCentreHandler}
                            >
                                <Iconify icon={IconCode.close} width={24} />
                            </CustomIconButton>
                        </div>
                    }
                    content={
                        <ChangeCentre
                            visitType={visitType}
                            onSuccess={addToCart}
                            centreUpdateHandler={centreUpdateHandler}
                            addToCartPayload={addToCartPayload}
                        />
                    }
                    maxWidth="md"
                    isCancel={true}
                />
            )}

            <SelectPatientForm
                open={patientPopupFlag}
                onSubmit={(data) => handlePatientSubmit(data)}
                onClose={patientClose}
                isDisabled={
                    addToCentreCartMutation.isLoading ||
                    addToHomeCartMutation.isLoading
                }
            />

            <LoginPopUp
                setOpen={setLoginPopUp}
                open={loginPopUp}
                onClose={onClose}
                title="Sign Up / Login"
            />

            <ErrorPopup
                open={!!error}
                onClose={onClosePopup}
                errorMessage={error}
            />

            <AddressMismatchPopup
                open={isMismatchOpen}
                onClose={() => {
                    setMismatchOpen(null);
                    patientClose();
                }}
                cartDetails={addToCartPayload}
            />
        </>
    );
};

export default TestActionAndControlSection;
